import { Node } from "@tiptap/core"
export default Node.create({
  name: "iframe",
  group: "block",
  atom: true,
  addOptions() {
    return {
      allowFullscreen: true,
      HTMLAttributes: {
        class: "iframe-wrapper",
        style: "position:relative; width:100%;",
      },
    }
  },
  addAttributes() {
    return {
      attrs: {
        default: {},
        parseHTML: (element) => {
          const result = {}
          for (const attr of element.attributes) {
            result[attr.name] = attr.value
          }
          return result
        },
        renderHTML: (attributes) => {
          return attributes.attrs || {}
        },
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: "iframe",
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    const { attrs, ...rest } = HTMLAttributes
    return ["div", this.options.HTMLAttributes, ["iframe", { ...attrs, ...rest }]]
  },
  addCommands() {
    return {
      setIframe:
        (options) =>
        ({ tr, dispatch }) => {
          const { selection } = tr

          const node = this.type.create(options)

          console.log(node)
          if (dispatch) {
            tr.replaceRangeWith(selection.from, selection.to, node)
          }
          return true
        },
    }
  },
})
